(function ($, Drupal) {
  // Header behaviors (Sticky, scroll direction...)
  Drupal.behaviors.initHeader = {
    attach: function (context, settings) {
      $(".js_stickyHeader", context)
        .once("initHeader")
        .each(function () {
          let $window = $(window),
            $body = $("body"),
            $resPixel = $(".js_resolution"),
            savedTop = 0,
            taxMenu = $(".taxonomy-menu");

          function stickyHeader() {
            let currentTop = $window.scrollTop();
            // HEADER ON SCROLL DOWN HIDE
            if (currentTop > savedTop) {
              if ($window.scrollTop() > 0) {
                $body.removeClass("is_sticky");
                $body.addClass("is_hidden");
                taxMenu.removeClass("topbar-present");
              }
            } else {
              $body.removeClass("is_hidden");

              taxMenu.addClass("topbar-present");
              $window.scrollTop() > 0
                ? $body.addClass("is_sticky")
                : $body.removeClass("is_sticky");
            }
            savedTop = currentTop;
          }

          function clearPromoBarClasses() {
            $body.removeClass("promo-2 promo-3");
          }

          function setPromoBar() {
            const $promoBar = $body.find(".header__notification");

            if ($promoBar) {
              clearPromoBarClasses();

              const $promoBarHeight = $promoBar.height();

              switch ($promoBarHeight) {
                case 44:
                  $body.addClass("promo-2");
                  break;
                case 62:
                  $body.addClass("promo-3");
                  break;
              }
            }
          }

          stickyHeader();
          setPromoBar();

          const trigger = throttle(e => {
            stickyHeader();
            setPromoBar();
          }, 300);

          $window.on({
            resize: function () {
              trigger();
            }
          });

          $window.on({
            scroll: function () {
              stickyHeader();
            }
          });

          const setPromoBarInteral = window.setInterval(setPromoBar, 1000);
        });
    }
  };
})(jQuery, Drupal);
